import { render } from "./MarketPriceOverview.vue?vue&type=template&id=4aa7769b"
import script from "./MarketPriceOverview.vue?vue&type=script&lang=js"
export * from "./MarketPriceOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__